import { render, staticRenderFns } from "./LoaderGlobal.vue?vue&type=template&id=35ac1e0f"
import script from "./LoaderGlobal.vue?vue&type=script&lang=js"
export * from "./LoaderGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports